import { gql, useLazyQuery, useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useUser } from "shared-components/Components/User/User.hook";
import cookie from "js-cookie";
import getConfig from "next/config";
import { getBaseDomain as loginBasePath } from "@Utils/Functions";

import {
	REGISTER_MUTATION,
	UPDATE_USER_MUTATION,
	USER_EXISTS_QUERY,
} from "shared-components/Components/User/User.querys";

const SEND_LEAD_MUTATION = gql`
	mutation sendLead($input: LeadInput!) {
		sendLead(input: $input) {
			id
		}
	}
`;

export const useSendTextLead = ({
	property_id,
	entity_type,
	message,
	source,
	isAutoGenerated = false,
	financing_information,
}) => {
	const { user, isLoggedIn } = useUser();
	// const { loginBasePath } = getConfig().publicRuntimeConfig;
	const [sendLeadMutation, { loading }] = useMutation(SEND_LEAD_MUTATION, {
		onError: error => {
			console.error("sendLead failed", error);
		},
	});

	const [
		userExistsCustomQuery,
		{ data: dataUserExistCustom, loading: userExistsCustomLoading },
	] = useLazyQuery(USER_EXISTS_QUERY, {
		fetchPolicy: "network-only",
	});

	const [
		registerMutation,
		{ loading: registerLoading, data: dataRegisterMutation },
	] = useMutation(REGISTER_MUTATION);

	const [updateUserMutation, { loading: updateLoading }] = useMutation(UPDATE_USER_MUTATION);

	const updateUser = ({ name, phone }) => {
		return updateUserMutation({ variables: { name, phone } });
	};

	const refreshAuth = data => {
		cookie.set("frontend_token", data.access_token, {
			expires: 365,
			domain: loginBasePath(),
			path: "/",
		});
		localStorage.setItem("user_md5", data.user_md5);
		user.refetch();
	};

	useEffect(() => {
		if (dataRegisterMutation) {
			refreshAuth(dataRegisterMutation.registerIndividual);
		}
	}, [dataRegisterMutation]);

	const sendLead = async (dataModal = null) => {
		if (!isLoggedIn && dataModal) {
			return userExistsCustomQuery({ variables: { email: dataModal.email } }).then(async data => {
				if (data?.error?.message?.includes("no existe")) {
					return registerMutation({
						variables: {
							email: dataModal.email,
							name: dataModal.name,
						},
					})
						.then(({ data }) => {
							return updateUser({
								name: dataModal.name,
								phone: dataModal.phone,
							}).then(async () => {
								user.refetch();
								let response = await sendLeadMutation({
									variables: {
										input: {
											name: dataModal.name,
											email: dataModal.email,
											phone: dataModal.phone,
											type: entity_type,
											property_id,
											message,
											source,
											isAutoGenerated,
											financing_information,
										},
									},
								});
								return { success: response?.data?.sendLead?.id ? true : false };
							});
						})
						.catch(error => {
							console.error(error);
						});
				} else {
					let response = await sendLeadMutation({
						variables: {
							input: {
								name: dataModal.name,
								email: dataModal.email,
								phone: dataModal.phone,
								type: entity_type,
								property_id,
								message,
								source,
								isAutoGenerated,
								financing_information,
							},
						},
					});
					return { success: response?.data?.sendLead?.id ? true : false };
				}
			});
		} else {
			let response = await sendLeadMutation({
				variables: {
					input: {
						type: entity_type,
						property_id,
						message,
						source,
						isAutoGenerated,
						financing_information,
					},
				},
			});
			return { success: response?.data?.sendLead?.id ? true : false };
		}
	};

	return {
		loading,
		sendLead,
	};
};
